import ArrayUtils from '@/utils/arrayUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import LoyaltyCardsServices from '@/services/loyaltyCards'
import AccountsSercice from '@/services/accounts'
import Vue from 'vue'

export default
{
    namespaced: true,
    
    state:
    {
        storeConfigs: {},
        storeRewards: {},
        storeRewardHistory: {},
        storeCreditHistory: {},
        storeCustomers: {},
    },

    getters:
    {
    },

    mutations:
    {
        setStoreConfig (state, config) 
        {
            Vue.set(state.storeConfigs, config.storeId, config)
        },

        updateStoreRewards (state, rewards) 
        {
            const storeId = rewards.storeId || rewards[0].storeId 
            var merged = ArrayUtils.mergeArrays(state.storeRewards[storeId], rewards, (a, b) => a.rewardId == b.rewardId)
        
            merged = merged.sort((a, b) =>
            {
                let dId = a.rewardId - b.rewardId

                return dId
            })

            Vue.set(state.storeRewards, storeId, merged )
        },

        updateStoreRewardHistory (state, rewards) 
        {
            const storeId = rewards.storeId || rewards[0].storeId 
            var merged = ArrayUtils.mergeArrays(state.storeRewardHistory[storeId], rewards, (a, b) => a.transactionId == b.transactionId)
        
            merged = merged.sort((a, b) =>
            {
                let dId = a.transactionId - b.transactionId

                return dId
            })

            Vue.set(state.storeRewardHistory, storeId, merged )
        },

        updateStoreCreditHistory (state, credits) 
        {
            const storeId = credits.storeId || credits[0].storeId 
            var merged = ArrayUtils.mergeArrays(state.storeCreditHistory[storeId], credits, (a, b) => a.transactionId == b.transactionId)
        
            merged = merged.sort((a, b) =>
            {
                let dId = a.transactionId - b.transactionId

                return dId
            })

            Vue.set(state.storeCreditHistory, storeId, merged)

            const customers = Array.from(new Set(merged.map(r => r.cardId))).map(cardId => ({ cardId }))
            Vue.set(state.storeCustomers, storeId, customers)
        },
    },

    actions:
    {
        removeRewardById ({ getters, state }, id)
        {
            let reward = ArrayUtils.flatten(Object.values(state.storeRewards)).find(r => r.rewardId == id)
            
            if (!reward) return console.warn('Could not find reward', id, 'for deletion')
            
            const rewards = state.storeRewards[reward.storeId]
            rewards.splice(rewards.indexOf(reward), 1)
 
            state.storeRewards[reward.storeId] = rewards
        },

        fetchCustomersDetails ({ getters, state }, {storeId, token})
        {
            return new Promise(async resolve =>
            {
                const rewardHistory = state.storeRewardHistory[storeId]
                const creditHistory = state.storeCreditHistory[storeId]
                const customers = await Promise.all(Array.from(new Set(rewardHistory.map(r => r.cardId))).map(async cardId =>
                {
                    const card = (await LoyaltyCardsServices.fetchCard(EnvironmentUtils.cityId, token, cardId))
                    const credits = creditHistory.filter(r => r.cardId == cardId)
                    const rewards = rewardHistory.filter(r => r.cardId == cardId)
                        
                    return ({
                        cardId,
                        ...card,
                        owner: (await AccountsSercice.searchAccount(card.ownerId, EnvironmentUtils.cityId)),
                        credits,
                        rewards,

                    })
                }))
                Vue.set(state.storeCustomers, storeId, customers)
                resolve(customers)
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/stores/storeLoyaltyCard.js